import { Decimal } from 'decimal.js';

/** Parse a user-entered string (locale-tolerant: accepts comma or dot decimal
 * separator, strips whitespace) into a Decimal. Empty/invalid input returns null. */
export function parseDecimal(value: string): Decimal | null {
  if (!value || value.trim() === '') return null;
  const normalized = value.replace(/\s/g, '').replace(',', '.');
  try {
    const parsed = new Decimal(normalized);
    return parsed.isNaN() ? null : parsed;
  } catch {
    return null;
  }
}
